import { ValidationInterface } from '../../../validation.interface';
import {
  FeedstockBmpPotentialDirect,
  FeedstockBmpPotentialDirectPropName
} from '../../../../../models/project/feedstock/feedstock-bmp-potential/feedstock-bmp-potential-type-models/feedstock-bmp-potential-direct.model';
import { ProjectValidationUnit } from '../../../../../models/data-structures/project-validation';
import { UnitValueValidation } from '../../unit-value.validation';

export class FeedstockBmpPotentialDirectValidation implements ValidationInterface {
  /** The current BMP potential direct obj that is being validated */
  bmpPotentialDirect: FeedstockBmpPotentialDirect;

  /**
   * Sets the current BMP potential direct obj that will be used for validation
   * @param bmpPotentialDirect will be used to set the current BMP potential direct obj
   */
  constructor(bmpPotentialDirect: FeedstockBmpPotentialDirect) {
    if (!bmpPotentialDirect) throw Error('invalid BMP potential direct provided for validation');
    this.bmpPotentialDirect = new FeedstockBmpPotentialDirect(bmpPotentialDirect);
  }

  /**
   * Get a validation unit containing the validation data for the current BMP potential direct obj
   * @param validationUnit, if provided will have the validation for the current BMP potential direct
   * added to it. If it is not provided a new validation unit will be returned.
   */
  getValidation(validationUnit = new ProjectValidationUnit()): ProjectValidationUnit {
    if (!this.bmpPotentialDirect) throw Error('unable to validate BMP potential direct');
    validationUnit.addModuleResults(
      new UnitValueValidation(this.bmpPotentialDirect.bmp).getValidation(),
      FeedstockBmpPotentialDirectPropName.bmp
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.bmpPotentialDirect.ch4Concentration).getValidation(),
      FeedstockBmpPotentialDirectPropName.ch4Concentration
    );
    return validationUnit;
  }

  /**
   * returns a boolean that determines if the current BMP potential direct obj is valid
   */
  isValid(): boolean {
    return this.getValidation().isValid;
  }
}
